import { required, email, max, integer } from 'vee-validate/dist/rules';
import { extend } from 'vee-validate';

extend('required', {
	...required,
	message: 'Trường dữ liệu là bắt buộc',
});

extend('max', {
	...max,
	message: 'Dữ liệu không được vượt quá {length} ký tự',
});

extend('email', {
	...email,
	message: 'Địa chỉ email không hợp lệ',
});

extend('required-input', {
	...required,
	params: ['vi_field'],
	message: 'Vui lòng nhập {vi_field}',
});

extend('required-number', {
	...required,
	params: ['vi_field'],
	message: 'Vui lòng nhập kí tự số',
});

extend('required-select', {
	...required,
	params: ['vi_field'],
	message: 'Vui lòng chọn {vi_field}',
});

extend('required-input-array', {
	...required,
	params: ['vi_field'],
	validate(value) {
		return Array.isArray(value) && value.length > 0;
	},
	message: 'Vui lòng chọn {vi_field}',
});

extend('required-phone', {
  ...required,
  validate(val = '') {
    const cleaned = val.replace(/\s+/g, '');

    // ---- Trường hợp conversation_id ----
    const conversationIdPattern = /^\d+_\d+_\d+_\d+$/;
    if (conversationIdPattern.test(cleaned)) {
      return true;
    }

    // ---- Trường hợp id nền tảng dạng t_... (vd: t_1276387678683) ----
    const platformIdPattern = /^t_\d+$/;
    if (platformIdPattern.test(cleaned)) {
      return true;
    }

    // ---- Trường hợp số Việt Nam ----
    // Bắt đầu bằng 0 và có 10 chữ số
    if (/^0\d{9}$/.test(cleaned)) {
      return true;
    }
    // +84xxxxxxxxx => chuyển thành 0xxxxxxxxx
    if (/^\+84\d{9}$/.test(cleaned) || /^84\d{9}$/.test(cleaned)) {
      return true;
    }

    // ---- Trường hợp số quốc tế khác ----
    // Bắt đầu bằng +, không phải +84, và có 8-15 chữ số
    if (/^\+(?!84)\d{8,15}$/.test(cleaned)) {
      return true;
    }

    return false;
  },
  message: 'Nhập số điện thoại hợp lệ (0xxxxxxxxx, +84xxxxxxxxx, 84xxxxxxxxx hoặc số quốc tế +xxxxxxxxx), conversation_id hoặc t_xxxxxxxxx',
});

extend('max-length', {
	validate(val = '', params) {
		if (val.length <= Number(params.maxLen)) {
			return true;
		}
		return false;
	},
	params: ['maxLen', 'vi_field'],
	message: '{vi_field} không vượt quá {maxLen} ký tự',
});

extend('integer-with-comma', {
	validate(val = '' /* , args */) {
		if (!val) return true;
		return !Number.isNaN(
			Number(val.replaceAll(',', ''))
		); /* && num <= Number(args.max) */
	},
	params: ['vi_field'],
	message: '{vi_field} phải ở dạng số nguyên',
});

extend('positive', {
	...integer,
	validate(val = '') {
		return Number(val) > 0;
	},
	message: 'Vui lòng nhập số lớn hơn 0',
});

extend('required-array', {
	validate(value) {
		return Array.isArray(value) && value.length > 0;
	},
	message: 'Vui lòng nhập trường {field}'
});

extend('array', {
	validate(val = '') {
		return val ? /(\w)+(,(\w)+)*$/.test(val) : true;
	},
	message: 'Danh sách các phần tử phân cách nhau bởi dấu phẩy',
});
